import {
  addEnvVariable,
  deleteEnvVariable,
  editEnvVariable,
  getAllEnvVariables,
} from 'shared/api/services/env-variables-service';

import type { EnvVariable, EnvVarWithId } from '@/enteties/env-variables/model';

export async function getAllVariables(slug: string): Promise<EnvVarWithId[]> {
  const res = await getAllEnvVariables(slug);
  if (!res.ok) throw Error(`${res.status}`);
  return await res.json();
}

export async function addVariable(
  slug: string,
  data: EnvVariable
): Promise<EnvVarWithId> {
  const res = await addEnvVariable(slug, data);
  if (!res.ok) throw Error(`${res.status}`);
  return await res.json();
}

export async function editVariable(
  slug: string,
  id: number,
  data: EnvVarWithId
): Promise<EnvVarWithId> {
  const res = await editEnvVariable(slug, id, data);
  if (!res.ok) throw Error(`${res.status}`);
  return await res.json();
}

export async function deleteVariable(slug: string, id: number) {
  const res = await deleteEnvVariable(slug, id);
  if (!res.ok) throw Error(`${res.status}`);
  return await res.json();
}
